import React from 'react'
import ErrorAlertsList, {
  CART_ALERT_ERROR_TYPES,
} from '../CartAlerts/ErrorAlertsList'

const CheckoutAlerts = ({ errori }) => {
  return (
    <ErrorAlertsList
      errori={errori}
      cartMain={null}
      filterTypes={[
        CART_ALERT_ERROR_TYPES.NO_SPEDIZIONE_GRATIS,
        CART_ALERT_ERROR_TYPES.NO_MULTIPLI,
      ]}
    />
  )
}

export default CheckoutAlerts
